<script>
export default {
    name: "PatientPreviousLabTests",

    data() {

        return {
            patients: [],
            searchText: ``,
        };
    },

    mounted() {
        
        this.fetchPatients();
    },

    methods: {

        fetchPatients() {
            this.$root.loading = true;
            let url = `PatientsReports/GetPatientList`;
            url += this.searchText ? `?SearchText=${this.searchText}` : ``;
            return this.$http.get(url).then(response => {
                this.patients = response.data;
                this.$root.loading = false;
            }).catch(() => { this.$root.loading = false; });
        },
    },
}
</script>
<template>
    <tail-base-layout>
        <template v-slot:content>
            <tail-card>
              <template v-slot:card-header>
                   <h5 class="font-semibold">Previous Tests </h5>
              </template>
              <template v-slot:card-body>
                  <div class="w-full overflow-auto max-h-screen">
                        <div class="w-full flex md:flex-row sm:flex-col">
                            <div class="md:w-1/4 sm:w-full p-tiny">
                                <input type="text" @keydown.enter="fetchPatients" v-model.trim="searchText" class="input-sm input-control text-sm" placeholder="Search">
                            </div>
                            <div class="md:w-1/4 sm:w-full p-tiny">
                                <button class="btn-sm btn-primary text-xs" @click.prevent="fetchPatients"><i class="fa fa-search"></i> Filter</button>
                            </div>
                        </div>
                        <table class="w-full table table-hover">
                            <thead class="bg-indigo-400 text-sm">
                                <tr class="flex text-white w-full">
                                    <th class="p-tiny w-1/3">Patient</th>
                                    <th class="p-tiny w-1/6">IP NO</th>
                                    <th class="p-tiny w-1/6">OP NO</th>
                                    <th class="p-tiny w-1/6">Mobile</th>
                                    <th class="p-tiny w-1/6">Inpatient</th>
                                    <th class="p-tiny w-1/12">Visits</th>
                                    <th class="p-tiny w-1/12">Select</th>
                                </tr>
                            </thead>
                            <tbody class="text-xs font-semibold bg-gray-100 flex flex-col items-center overflow-auto w-full" style="height: 65vh;">
                                <tr v-for="(pat, idx) in patients" :key="idx" class="flex w-full">
                                    <td class="p-tiny w-1/3">
                                        <h5 class="text-sm text-gray-900">{{ pat.names }}</h5>
                                        <h5 class="text-xs leading-5 text-gray-700">MRN: {{ pat.patienT_ID }}</h5>
                                        <h5 class="text-xs leading-5 text-gray-700">DOB: {{ pat.dob | dateFormat }}</h5>
                                        <h5 class="text-xs leading-5 text-gray-700">Gender: {{ pat.gender }}</h5>
                                    </td>
                                    <td class="p-tiny w-1/6">{{ pat.ipfileno }}</td>
                                    <td class="p-tiny w-1/6">{{ pat.opfileno }}</td>
                                    <td class="p-tiny w-1/6">{{ pat.celL_PHONE }}</td>
                                    <td class="p-tiny w-1/6">{{ pat.iS_IN_PATIENT }}</td>
                                    <td class="p-tiny w-1/12"><span class="ml-4">{{ pat.visitCount }}</span></td>
                                    <td class="p-tiny w-1/12">
                                        <router-link 
                                            class="btn-sm text-xs btn-primary ml-4"
                                            :to="{ name: `lab.previous-results.view`, params: {patientID: pat.patienT_ID }}"><i class="fa fa-eye"></i></router-link>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                  </div>
              </template>
            </tail-card>
        </template>
    </tail-base-layout>
</template>